var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"d-flex flex-column py-3",attrs:{"fluid":""}},[_c('b-table',{attrs:{"hover":"","no-border-collapse":"","selectable":"","select-mode":"single","sticky-header":"","thead-tr-class":"small","tbody-tr-class":"h5","items":_vm.items,"fields":_vm.computedFields},on:{"row-selected":_vm.onRowSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }